import styled from "styled-components";

export const UserStatusRespawnStyled = styled.div`
    background: radial-gradient(65.22% 65.22% at 50% 15.22%, rgba(122, 243, 134, 0.08) 0%, rgba(243, 241, 122, 0) 100%), var(--color-background-secondary);
    box-shadow: var(--shadow-primary);
    padding: 16px;
    border-radius: 16px;
    text-align: center;
    cursor: pointer;
    
    > div {
        display: flex;
        justify-content: center;
    }
`;
